export default "__VITE_ASSET__Boxswktk__"